<template>
  <v-card outlined class="rounded-lg ppim23-card d-flex align-center justify-center">
    <h2 class="py-10 red--text text--lighten-2">{{ this.message }}</h2>
  </v-card>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: "เกิดข้อผิดพลาด"
    }
  }
}
</script>
